/* eslint-disable max-len */
interface CalendarAscProps {
  className?: string;
  fill?: string;
  height?: string;
  width?: string;
}

const CalendarAsc = ({
  className = '',
  fill = '#0368A1',
  height = '18',
  width = '23',
  ...props
}: CalendarAscProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 23 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18 4H15L19 0L23 4H20V18H18V4ZM7 13H10V10H7V13ZM12 2H11V0H9V2H5V0H3V2H2C0.89 2 0 2.89 0 4V15C0 16.11 0.89 17 2 17H12C13.11 17 14 16.11 14 15V4C14 2.89 13.11 2 12 2ZM2 15V8H12V15H2Z"
        fill={fill}
      />
    </svg>
  );
};

export default CalendarAsc;